import React from 'react';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCreateWorkingHours } from 'src/features/workingHours/api/useCreateWorkingHours';
import WorkingHoursFormModal from 'src/features/workingHours/components/form/WorkingHoursFormModal';
import { workingHoursMessages } from 'src/features/workingHours/utils/messages';
import { WorkingHours } from 'src/features/workingHours/utils/types';
import { useParking } from 'src/providers/ParkingProvider';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';

interface WorkingHoursFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedWorkingHours?: WorkingHours;
    children?: React.ReactNode;
}

function CreateWorkingHoursFormModal<TData>({ className, semantics }: WorkingHoursFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { siteId = '' } = useParams();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateWorkingHours({});

    return (
        <WorkingHoursFormModal
            className={className}
            mutate={(values, onSuccess, onError) => {
                values.map((data, index) =>
                    mutate({ siteId, parkingId, ...data }, index === values.length - 1 ? { onSuccess, onError } : {}),
                );
            }}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={faPlus}
            isPending={isPending}
            subtitle={formatMessage(workingHoursMessages.addWorkingHoursSubtitle)}
        />
    );
}

export default CreateWorkingHoursFormModal;
